import { useMemo, useState } from "react";
import { axiosGetWithHeader, axiosPostWithHeader, ShowAlertError } from "../Common/axios";
import { AppHeader } from "./AppHeader";
import { Link, useLocation } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import { AppFooter } from "./AppFooter";

import { AstrologerInfoFooter } from "../Common/AstrologerInfoFooter";
import { TransitChartPageMenu } from "./TransitChartPageMenu";
import { TransitChartTab } from "./Basic/TransitChartTab";
import { TransitCuspalInIntervalTab } from "./Basic/TransitCuspalInIntervalTab";
import { TransitPlanetInIntervalTab } from "./Basic/TransitPlanetInIntervalTab";

export function TransitChartPage()  {
  const {state} = useLocation();
  const runningId = state?state.runningId:null;
  const [userData, setUserData] = useState(null);
  const [clientData, setClientData] = useState(null);
  const [transitData, setTransitData] = useState(null);
  const [menuArray, setMenuArray] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Transit Page Page');
  const [errorAlert, setErrorAlert] = useState(null);
  const handleMenu = (menuArray)=>setMenuArray(menuArray);
  const [transitIntervalData, setTransitIntervalData] = useState([]);
  const [date, setDate] = useState([]);
  const [startTime, setStartTime] = useState([]);
  const [endTime, setEndTime] = useState([]);

  useMemo(() => {
    axiosGetWithHeader("/userrequest/"+runningId,
      (response)=>{
        setUserData(response.data);
        getClientData(response.data.id);
        getTransitData(response.data.id);
        getTransitInInterval({});
      },
      (error)=>{
        setUserData(null);
        setSpinner(null);
        console.log(error);
        setErrorAlert(error.message);
      }
    );
  }, [runningId]);

  function getClientData(clientId) {
    axiosGetWithHeader("/chart/userdata/"+clientId,
      (response)=>{
        setClientData(response.data);
      },
      (error)=>{
        console.log(error);
        setClientData(null);
        setErrorAlert(error.message);
      }
    );
  }

  function getTransitData(clientId) {
    axiosGetWithHeader("/chart/transitchart/"+clientId,
      (response)=>{
        setTransitData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setTransitData([]);
        setErrorAlert(error.message);
      }
    );
  }

  function getTransitInInterval(requestdata) {
    axiosPostWithHeader("/chart/dateintervalsearch", requestdata,
      (response)=>{
        setTransitIntervalData(response.data);
        setDate(response.data.startDate.substring(0,10));
        setStartTime(response.data.startDate.substring(11));
        setEndTime(response.data.endDate.substring(11));
      },
      (error)=>{
        console.log(error);
        setTransitIntervalData(null);
        setDate(null);
        setStartTime(null);
        setEndTime(null);
        setErrorAlert(error.message);
      }
    );
  }

  const handleCalculate = (startTime,endTime)=>{
    if(startTime===null||startTime===undefined||endTime===null||endTime===undefined) return;
    const requestdata = {
      "startDate":date+"T"+startTime+(startTime.length===5?":00":""),
      "endDate":date+"T"+endTime+(endTime.length===5?":00":"")
    }
    getTransitInInterval(requestdata);
  }

  return (
    <>
        <div class="m-0 p-0 row sticky-top bg-white noprint">
            <div class="m-0 p-0 col-12">
                <AppHeader/>
                <TransitChartPageMenu userData={userData} handleMenu={handleMenu} />
            </div>    
        </div> 
        {spinner===null?<></>:<div class="text-center text-primary h5 pt-5">{spinner} <Spinner animation="border" size="sm" /></div>}
        { clientData===null || clientData===undefined || clientData.length===0 
            || userData===null || userData===undefined || userData.length===0 ?<div class="menupageheight"></div>:
            transitData===null || transitData===undefined || transitData.length===0 
            || transitData.birthChart===null || transitData.birthChart.house===null || transitData.planetPosition===null || transitData.cuspalPosition===null
            ?<div class="menupageheight">
              <table class="m-0 p-0 table">
                <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Transit Chart</h4></caption>
              </table>
              Add your city in <Link to="/cprofile.html">My Profile</Link> page to view Transit Chart.
            </div>:
        <>
        <div class="m-0 p-0 row align-items-top content">
            <div class="m-0 p-0 col-12">
              <div class="menupageheight">
                <TransitChartTab menuArray={menuArray} userData={userData} clientData={clientData} transitData={transitData}/>
                <TransitCuspalInIntervalTab menuArray={menuArray} transitIntervalData={transitIntervalData} date={date} startTime={startTime} endTime={endTime} setDate={setDate} setStartTime={setStartTime} setEndTime={setEndTime} handleCalculate={handleCalculate}/>
                <TransitPlanetInIntervalTab menuArray={menuArray} transitIntervalData={transitIntervalData} date={date} startTime={startTime} endTime={endTime} setDate={setDate} setStartTime={setStartTime} setEndTime={setEndTime} handleCalculate={handleCalculate}/>
              </div>  
            </div>
        </div>
        </>}
        <div class="m-0 p-0 row noprint">
            <div class="m-0 p-0 col-12">
                <AppFooter/>
            </div>    
        </div>
        <div class="m-0 p-0 row d-none d-print-block printfooter">
          <div class="m-0 p-0 col-12">
            <AstrologerInfoFooter userData={userData}  />
          </div>    
        </div> 
        <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
    </>
  );
}
